import isFunction from "lodash/isFunction";
import PropTypes from "prop-types";
import { cloneElement, Component, createRef } from "react";
import ReactDOM from "react-dom";

export default class Portal extends Component {
    constructor() {
        super();

        this.childrenRef = createRef();
        this.wrapperElement = document.createElement("div");
        this.wrapperElement.classList.add("Portal");
    }

    componentDidMount() {
        document.body.appendChild(this.wrapperElement);
        if (isFunction(this.props.handleRef)) {
            this.props.handleRef(this.childrenRef);
        }
    }

    componentWillUnmount() {
        document.body.removeChild(this.wrapperElement);
    }

    render() {
        return ReactDOM.createPortal(cloneElement(this.props.children, { ref: this.childrenRef }), this.wrapperElement);
    }
}

Portal.defaultProps = {
    handleRef: () => {},
};

Portal.propTypes = {
    children: PropTypes.node.isRequired,
    handleRef: PropTypes.func,
};
